var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reviewTaskManage"},[_c('el-container',[_c('headTop',{attrs:{"data":'/recordReview/reviewTaskManage'}}),_c('router-view'),_c('el-footer',[_c('foot')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }